import MyTeamWorkScheduleComponent from "../components/MyTeamWorkSchedule";
import useMyTeamWorkSchedule from "../hooks/useMyTeamWorkSchedule";

function MyTeamWorkSchedule() {
  const useMyTeamWorkScheduleProps = useMyTeamWorkSchedule();
  return <MyTeamWorkScheduleComponent {...useMyTeamWorkScheduleProps} />;
}

export default MyTeamWorkSchedule;
